/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

export default function isValidConnectorTemplate(json) {
  try {
    const parsed = typeof json === 'object' ? json : JSON.parse(json);

    return parsed.appliesTo && typeof parsed.appliesTo === 'object';
  } catch {
    return false;
  }
}
